/**
 * Service hooks barrel exports
 * Provides clean imports for all React service hooks
 *
 * Usage:
 * import { useUserService, useAgentService } from '@/hooks/services';
 */

export { useUserService } from "./use-user-service";
export { useAgentService } from "./use-agent-service";
export { useAdminService } from "./use-admin-service";
export { useAuthService } from "./use-auth-service";
export { useChatService } from "./use-chat-service";
export { usePowerPointTemplateService } from "./use-powerpoint-template-service";

// Export hook types for advanced usage
export type {} from // Add hook return types when needed for TypeScript consumers
"./use-user-service";
